import { Record } from 'immutable';

import { TaskListEntity } from '../../ui/components/app-task-modal/app-task-list.entity';

export const TaskSliceKey = 'task';

interface ITaskSliceState {
	loading: boolean;
	list: TaskListEntity;
	viewActiveJobs: boolean;
}

const taskDefaults: ITaskSliceState = {
	loading: true,
	list: TaskListEntity.build([]),
	viewActiveJobs: true,
};

export class TaskSliceState extends Record<ITaskSliceState>(taskDefaults) {
	public setLoading(isLoading: boolean): TaskSliceState {
		return this.set('loading', isLoading);
	}

	public setTaskList(taskList: TaskListEntity): TaskSliceState {
		return this.set('list', taskList);
	}

	public setViewActiveJobs(activeJobs: boolean): TaskSliceState {
		return this.set('viewActiveJobs', activeJobs);
	}
}
